import React, { FC, useRef, useCallback, useEffect } from "react"

type TProps = { visible: boolean; map: any; data: any }
const LayerNames: FC<TProps> = ({ data, visible, map }) => {
  const ref = useRef<any>()
  const clear = useCallback(() => {
    if (ref.current) {
      ref.current.forEach((m) => {
        m.setMap(null)
      })
      ref.current = null
    }
  }, [ref])
  useEffect(() => {
    if (!visible) {
      clear()
    } else if (map) {
      clear()
      const AMap = window.AMap
      let markers = (ref.current = [])
      data.forEach((p) => {
        let transform = "rotate(90deg)"
        if (p.bearing > 0) {
          transform = "rotate(-90deg)"
        }
        var text = new AMap.Text({
          text: p.name,
          anchor: "center", // 设置文本标记锚点
          draggable: false,
          cursor: "pointer",
          angle: p.bearing,
          style: {
            // padding: ".75rem 1.25rem",
            // "margin-bottom": "1rem",
            // "border-radius": ".25rem",
            // "background-color": "white",
            // width: "15rem",
            // "border-width": 0,
            // "box-shadow": "0 2px 6px 0 rgba(114, 124, 245, .5)",
            // "text-align": "center",
            // "font-size": "20px",
            color: p.nameColor || "#00FFDB",
            border: "none",
            background: "none",
            // transform,
          },
          position: p.nameCoord,
        })

        text.setMap(map)
        markers.push(text)
      })
    }
    return () => {
      clear()
    }
  }, [map, visible, clear, ref, data])

  return null
}
export default LayerNames
